// src/components/MenuScreen.js
import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Fade,
} from '@mui/material';
import navItems from '../constants/navItems';
import { useTheme } from '../contexts/ThemeContext';

const MenuScreen = ({ onNavigate }) => {
  // Get dark mode state
  const { darkMode } = useTheme();

  // Handle navigation with path information
  const handleNavigation = (item) => {
    if (!onNavigate) return;
    
    // If the item has a special screen property, navigate to that screen
    if (item.screen) {
      onNavigate(item.text, null, item.screen);
      return;
    }
    
    // If the item has no path and is not Home, do nothing
    if (!item.path && item.text !== 'Home') {
      console.log(`No path configured for: ${item.text}`);
      return;
    }
    
    // Normal navigation with text and path
    onNavigate(item.text, item.path);
  };

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          minHeight: '100vh',
          // Adjust gradient based on dark mode
          background: darkMode 
            ? 'linear-gradient(135deg, #1a237e, #ffd600)'  // Darker gradient for dark mode
            : 'linear-gradient(135deg, #3f51b5, #ffeb3b)', // Original gradient for light mode
          p: { xs: 2, sm: 3 },
        }}
      >
        {/* Header */}
        <Typography
          variant="h3"
          align="center"
          sx={{
            color: '#fff',
            mb: 4,
            fontWeight: 'bold',
            textShadow: '1px 1px 3px rgba(0,0,0,0.3)',
          }}
        >
          Menu
        </Typography>

        {/* Grid of Navigation Cards */}
        <Grid container spacing={3}>
          {navItems.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  borderRadius: 2,
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                  },
                  // Gray out cards that don't have a path configured
                  opacity: (!item.path && item.text !== 'Home' && !item.screen) ? 0.6 : 1,
                  // Apply dark mode styling
                  bgcolor: darkMode ? 'background.paper' : 'background.paper',
                }}
                onClick={() => handleNavigation(item)}
              >
                <CardActionArea sx={{ p: 2 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: darkMode ? '#7986cb' : '#3f51b5', // Lighter blue for dark mode
                      mb: 2,
                      fontSize: 48,
                    }}
                  >
                    {item.icon}
                  </Box>
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" component="div">
                      {item.text}
                    </Typography>
                    {/* Optional: Show path for debugging */}
                    {process.env.NODE_ENV === 'development' && item.path && (
                      <Typography variant="caption" color="text.secondary">
                        Path: {item.path}
                      </Typography>
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Fade>
  );
};

export default MenuScreen;